<div class="apps-book-widget-desktop-skeleton">
  <div class="apps-book-widget-desktop-skeleton__row-1">
    <mach-skeleton-loader
      [shape]="'headline'"
      class="apps-book-widget-desktop-skeleton__row-1__trip-details"
    ></mach-skeleton-loader>
  </div>

  <div class="apps-book-widget-desktop-skeleton__row-2">
    <div
      class="apps-book-widget-desktop-skeleton__row-2__pair"
      *ngFor="let i of [1, 2, 3, 4]"
    >
      <mach-skeleton-loader
        [shape]="'headline'"
        class="apps-book-widget-desktop-skeleton__row-2__pair__checkbox"
      ></mach-skeleton-loader>
      <mach-skeleton-loader
        [shape]="'headline'"
        class="apps-book-widget-desktop-skeleton__row-2__pair__label"
      ></mach-skeleton-loader>
    </div>
  </div>

  <div class="apps-book-widget-desktop-skeleton__row-3">
    <div class="apps-book-widget-desktop-skeleton__row-3__left">
      <mach-skeleton-loader
        [shape]="'headline'"
        class="apps-book-widget-desktop-skeleton__row-3__left__checkbox"
      ></mach-skeleton-loader>
      <mach-skeleton-loader
        [shape]="'headline'"
        class="apps-book-widget-desktop-skeleton__row-3__left__label"
      ></mach-skeleton-loader>
    </div>
    <mach-skeleton-loader
      [shape]="'headline'"
      class="apps-book-widget-desktop-skeleton__row-3__options-bar"
    ></mach-skeleton-loader>
  </div>

  <div class="apps-book-widget-desktop-skeleton__row-4">
    <mach-skeleton-loader
      [shape]="'headline'"
      class="apps-book-widget-desktop-skeleton__row-4__headline"
    ></mach-skeleton-loader>
    <mach-skeleton-loader
      [shape]="'button'"
      class="apps-book-widget-desktop-skeleton__row-4__button"
    ></mach-skeleton-loader>
  </div>
</div>
